import { command } from "@lookiero/messaging";
const CLEAR_NOTIFICATIONS = "clear_notifications";
const clearNotifications = () => command({ name: CLEAR_NOTIFICATIONS });
export { CLEAR_NOTIFICATIONS, clearNotifications };
